// components/PromocodeWidget/RewardItem/RewardItem.jsx
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Link from '../../AppLink';
import GiftIcon from '../../../icons/gift.svg';

// Router
import { getRoute, paths } from '../../../entry/routes';

import styles from './RewardItem.styl';

const cx = classNames.bind(styles);

export default function RewardItem(props) {
  const {
    message,
    applied,
    goods,
    code,
    idx,
    allConditionsChecked,
    reward,
    isOutOfStock,
    onOpenModal,
  } = props;

  const hasGoods = goods.length > 0;
  const isGood = reward === 'good';

  const isMainClickable = isGood && allConditionsChecked && !applied && hasGoods && !isOutOfStock;

  const Component = isMainClickable ? Link : 'div';
  const to = hasGoods ? getRoute(paths.stockGifts, idx, code) : getRoute(paths.home);

  const handleClick = e => {
    if (!onOpenModal) {
      return;
    }

    // если это "не активная" карточка — ничего не делаем
    if (!isMainClickable) {
      return;
    }

    e.preventDefault();
    onOpenModal({ isReplace: false });
  };

  const handleReplaceClick = e => {
    if (!onOpenModal) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    onOpenModal({ isReplace: true });
  };

  return (
    <Component
      className={cx('RewardItem', {
        RewardItem_applied: applied && !isOutOfStock,
        RewardItem_avaivable: allConditionsChecked && !applied && !isOutOfStock,
        RewardItem_outOfStock: isOutOfStock,
      })}
      to={to}
      onClick={handleClick}
    >
      <div
        className={cx('RewardItem__content', {
          RewardItem__content_outOfStock: isOutOfStock,
        })}
      >
        <div className={cx('RewardItem__message')}>
          <GiftIcon className={cx('RewardItem__icon')} />
          {message}
        </div>

        {(goods.length > 1 || goods[0]?.variations?.length > 1) && applied && !isOutOfStock && (
          <Link
            to={`${to}?replace`}
            className={cx('RewardItem__replace')}
            onClick={handleReplaceClick}
          >
            <FormattedMessage id="promocode.reward.replace" />
          </Link>
        )}
      </div>
    </Component>
  );
}

RewardItem.defaultProps = {
  allConditionsChecked: false,
  goods: [],
  isOutOfStock: false,
  onOpenModal: undefined,
};

RewardItem.propTypes = {
  message: PropTypes.string.isRequired,
  reward: PropTypes.string.isRequired,
  applied: PropTypes.bool.isRequired,
  allConditionsChecked: PropTypes.bool,
  goods: PropTypes.array,
  code: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  isOutOfStock: PropTypes.bool,
  onOpenModal: PropTypes.func,
};
